import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET
} from '../env';

const isCypress = (window as any).Cypress;

const config = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
  projectId: isCypress ? 'demo-e2e' : REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID
};
firebase.initializeApp(config);

if (isCypress) {
  firebase.firestore().settings({
    host: '127.0.0.1:8080',
    ssl: false,
    experimentalForceLongPolling: true
  });
  firebase.auth().useEmulator('http://localhost:9099');
  firebase.storage().useEmulator('localhost', 9199);

  // Cypress テスト用に window.firebase を公開
  // admin アプリはバンドル方式（Parcel）を使用しており、Firebase SDK は
  // index.js にバンドルされています。/__/firebase/init.js による自動注入は
  // CDN 方式（<script src="/__/firebase/...">）を使用する場合のみ有効なため、
  // テストコードから cy.window().its('firebase') でアクセスできるよう
  // ここで明示的に window オブジェクトに公開しています。
  (window as any).firebase = firebase;
}
